import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefinancaBanner = _resolveComponent("RefinancaBanner")!
  const _component_CookieConsent = _resolveComponent("CookieConsent")!
  const _component_OfficialCommunicationPopup = _resolveComponent("OfficialCommunicationPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentMain))),
    false
      ? (_openBlock(), _createBlock(_component_RefinancaBanner, {
          key: 0,
          isCookieVisible: _ctx.isCookieVisible
        }, null, 8, ["isCookieVisible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_CookieConsent, { onCookieStatusChange: _ctx.onCookieStatusChange }, null, 8, ["onCookieStatusChange"]),
    _createVNode(_component_OfficialCommunicationPopup)
  ], 64))
}